import axios from '@utils/axios';
// eslint-disable-next-line import/no-extraneous-dependencies

const createTemplate = {
  state: {
    categoryList: [],
    category: {},
    subCategoryList: [],
    subCategory: {},
    gender: 1,
    phenotype: '',
    geneCombination: {},
    geneCombinationList: [],
    genetypeCombinations: [],
    genetypeCombinationsNotUnique: {},
    numberOfCombinations: 1,
    template: '',
    templateEn: '',
    templateId: null,
    stepNumber: 1,
    note: '',
    risk: 1,
    customerCount: 0,
    emailBody: ''
  },
  getters: {
    getCategories(state) {
      return state.categoryList;
    },
    getCategory(state) {
      return state.category;
    },
    getSubCategories(state) {
      return state.subCategoryList;
    },
    getSubCategory(state) {
      return state.subCategory;
    },
    getStepNumber(state) {
      return state.stepNumber;
    },
    getGeneCombinations(state) {
      return state.geneCombinationList;
    },
    getGeneCombination(state) {
      return state.geneCombination;
    },
    getGender: (state) => () => {
      if (state.geneCombination.gender) {
        return state.geneCombination.gender.value;
      }
      return state.gender;
    },
    getPhenotype(state) {
      return state.phenotype;
    },
    getGenetypeCombinations(state) {
      return state.genetypeCombinations;
    },
    getNumberOfCombinations(state) {
      return state.numberOfCombinations;
    },
    getTemplate(state) {
      return state.template;
    },
    getTemplateEn(state) {
      return state.templateEn;
    },
    getCategoryId(state) {
      return state.category.id === 0 ? null : state.category.id;
    },
    getSubCategoryId(state) {
      return state.subCategory.id === 0 ? null : state.subCategory.id;
    },
    getGeneCombinationId(state) {
      return state.geneCombination.id === 0 ? null : state.geneCombination.id;
    },
    getGeneCombinationStringArray(state) {
      if (state.geneCombination.name) { return state.geneCombination.name.split(',').map((x) => x.trim()); }
      return [];
    },
    getGenoTypeCombinationsArray: (state) => () => {
      const genotypeCombinations = [];
      for (let i = 1; i <= state.numberOfCombinations; i += 1) {
        const combination = {};
        for (let j = 0; j < state.genetypeCombinations.length; j += 1) {
          combination[state.genetypeCombinations[j].Name] = state.genetypeCombinations[j][i];
        }
        genotypeCombinations.push(combination);
      }
      return genotypeCombinations;
    },
    getTemplateId(state) {
      return state.templateId;
    },
    getSubCategoryName(state) {
      return state.subCategory.name === 'None' ? null : state.subCategory.name;
    },
    getNote(state) {
      return state.note;
    },
    getRisk(state) {
      return state.risk;
    }
  },
  mutations: {
    setCategories(state, categories) {
      state.categoryList = categories;
    },
    setSubCategories(state, subcategories) {
      state.subCategoryList = subcategories;
    },
    setCategory(state, category) {
      state.category = category === null ? state.category : category;
    },
    setSubCategory(state, category) {
      state.subCategory = category === null ? state.subCategory : category;
    },
    nextStep(state) {
      state.stepNumber += 1;
    },
    previousStep(state) {
      state.stepNumber -= 1;
    },
    setGeneCombinations(state, combinations) {
      state.geneCombinationList = combinations;
    },
    setGeneCombination(state, combination) {
      state.geneCombination = combination === null ? state.geneCombination : combination;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setPhenotype(state, phenotype) {
      state.phenotype = phenotype;
    },
    setGenetypeCombinations(state, combinations) {
      state.genetypeCombinations = combinations;
    },
    setNumberOfCombinations(state, number) {
      state.numberOfCombinations = number;
    },
    setTemplate(state, template) {
      state.template = template;
    },
    setTemplateEn(state, templateEn) {
      state.templateEn = templateEn;
    },
    setStepNumber(state, no) {
      state.stepNumber = no;
    },
    setTemplateId(state, id) {
      state.templateId = id;
    },
    setNote(state, note) {
      state.note = note;
    },
    setGenetypeCombinationsNotUnique(state, nonunique) {
      state.genetypeCombinationsNotUnique = nonunique;
    },
    setRisk(state, risk) {
      state.risk = risk;
    },
    setCustomerCount(state, count) {
      state.customerCount = count;
    },
    setEmailBody(state, body) {
      state.emailBody = body;
    }
  },
  actions: {
    fetchCategories(context) {
      axios
        .get('admin/templates/getcategories')
        .then((res) => {
          context.commit('setCategories', res.data.categories);
        })
        .catch(() => {
          context.commit('setCategories', []);
        });
    },
    fetchSubCategories(context, categoryId) {
      axios
        .get('admin/templates/getsubcategories', {
          params: {
            CategoryId: categoryId
          }
        })
        .then((res) => {
          context.commit('setSubCategories', res.data.subcategories);
        })
        .catch(() => {
          context.commit('setSubCategories', []);
        });
    },
    fetchGeneCombinations(context, categoryId) {
      axios
        .get('admin/templates/getgenecombinations', {
          params: {
            CategoryId: categoryId
          }
        })
        .then((res) => {
          const combinations = [];
          res.data.combinations.forEach((comb) => {
            combinations.push({
              id: comb.id,
              name: comb.combinationGeneCode.join(', '),
              phenotype: comb.phenotype,
              gender: comb.gender
            });
          });
          context.commit('setGeneCombinations', combinations);
        })
        .catch(() => {
          context.commit('setGeneCombinations', []);
        });
    },
    createRequest(context) {
      return axios.put('admin/templates/create', {
        categoryId: context.getters.getCategoryId,
        category: context.state.category.name,
        subCategoryId: context.getters.getSubCategoryId,
        subCategory: context.getters.getSubCategoryName,
        phenotype: context.state.phenotype,
        gender: context.state.gender,
        geneCombinationId: context.getters.getGeneCombinationId,
        geneCombination: context.getters.getGeneCombinationStringArray,
        genotypeCombinations: context.getters.getGenoTypeCombinationsArray(),
        templateText: context.state.template,
        templateEnText: context.state.templateEn,
        note: context.state.note,
        UserId: context.rootState['vue-auth'].user.id,
        risk: context.state.risk
      });
    },
    editRequest(context) {
      return axios.patch('admin/templates/edit', {
        templateId: context.state.templateId,
        genotypeCombinations: context.getters.getGenoTypeCombinationsArray(),
        templateText: context.state.template,
        templateEnText: context.state.templateEn,
        note: context.state.note,
        risk: context.state.risk,
        emailBody: context.state.emailBody
      });
    },
    validateGenotypeCombinations(context) {
      return axios.post('admin/templates/validate-genotype-combinations', {
        templateId: context.state.templateId,
        categoryId: context.getters.getCategoryId,
        category: context.state.category.name,
        subCategoryId: context.getters.getSubCategoryId,
        subCategory: context.getters.getSubCategoryName,
        phenotype: context.state.phenotype,
        gender: context.state.gender,
        geneCombinationId: context.getters.getGeneCombinationId,
        geneCombination: context.getters.getGeneCombinationStringArray,
        genotypeCombinations: context.getters.getGenoTypeCombinationsArray()
      });
    },
    validateGeneCombination(context) {
      return axios.post('admin/genecombinations/validate-gene-combination', {
        categoryId: context.getters.getCategoryId,
        subCategoryId: context.getters.getSubCategoryId,
        phenotype: context.state.phenotype,
        gender: context.state.gender,
        geneCombinationId: context.getters.getGeneCombinationId,
      });
    },
    resetContext(context) {
      context.commit('setCategory', {});
      context.commit('setGender', 1);
      context.commit('setPhenotype', '');
      context.commit('setGeneCombination', {});
      context.commit('setGenetypeCombinations', []);
      context.commit('setNumberOfCombinations', 1);
      context.commit('setTemplate', '');
      context.commit('setTemplateEn', '');
      context.commit('setTemplateId', null);
      context.commit('setStepNumber', 1);
      context.commit('setSubCategory', {});
      context.commit('setNote', '');
      context.commit('setGenetypeCombinationsNotUnique', {});
      context.commit('setRisk', 1);
    },
    fetchTemplateById(context, id) {
      return axios.get('admin/templates/gettemplate', {
        params: {
          Id: id
        }
      })
        .then((res) => {
          const genes = Object.keys(res.data.result.genotypeCombinations[0].combination);
          const result = [];
          genes.forEach((gene) => {
            const obj = { Name: gene };
            for (let i = 0; i < res.data.result.genotypeCombinations.length; i += 1) {
              obj[i + 1] = res.data.result.genotypeCombinations[i].combination[gene];
            }
            result.push(obj);
          });
          context.commit('setGenetypeCombinations', result);
          context.commit('setNumberOfCombinations', res.data.result.genotypeCombinations.length);
          context.commit('setTemplate', res.data.result.text);
          context.commit('setTemplateEn', res.data.result.textEn);
          context.commit('setNote', res.data.result.note);
          context.commit('setTemplateId', id);
          context.commit('setRisk', res.data.result.risk);
          context.commit('setCustomerCount', res.data.result.customerCount);
        }).catch(() => {

        });
    },
  },
  namespaced: true
};

export default createTemplate;
